import Signal from 'libs/signals';

export const lenderAccessSignal = Signal({
  selectedUser: null,
  lenders: [],
  lendersInView: [],
  lendersFilteredBySearch: [],
  page: 0,
});
